/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakeintro1Inputs */

const en_intakeintro1 = /** @type {(inputs: Intakeintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop everything you have: contracts, quotes, invoices, receipts, photos of defects, and the WhatsApp chat with the contractor (export it from WhatsApp as a .txt file). The AI will read each file, categorize it, and pull dated events into your timeline. You'll get a chance to fill any gaps in chat afterwards.`)
};

const pt_intakeintro1 = /** @type {(inputs: Intakeintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junte tudo o que tem: contratos, orçamentos, faturas, recibos, fotos de defeitos, e a conversa de WhatsApp com o empreiteiro (exporte do WhatsApp como ficheiro .txt). A IA lê cada ficheiro, categoriza, e extrai os eventos com data para a sua cronologia. Depois pode preencher o que falte por chat.`)
};

/**
* | output |
* | --- |
* | "Drop everything you have: contracts, quotes, invoices, receipts, photos of defects, and the WhatsApp chat with the contractor (export it from WhatsApp as a ...." |
*
* @param {Intakeintro1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakeintro1 = /** @type {((inputs?: Intakeintro1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakeintro1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakeintro1(inputs)
	return pt_intakeintro1(inputs)
});
export { intakeintro1 as "intakeIntro" }